/* istanbul ignore file*/
import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { UtilityService } from 'src/app/core/services/utility.service';
import { IClaimMessage } from 'src/app/model/sitefinity/IFileAClaim';
import { AsappChatService } from '../../../../../core/services/asapp-chat.service';

@Component({
  selector: 'pgh-claims-message',
  templateUrl: './claims-message.component.html',
  styleUrls: ['./claims-message.component.scss'],
})
export class ClaimsMessageComponent {
  @Input() claimMessageInfo: IClaimMessage;
  @Input() showChatCTA: boolean = true;

  constructor(
    public matDialog: MatDialog,
    public resourceService: ADPResourceService,
    public utilityService: UtilityService,
    private activatedRoute: ActivatedRoute,
    private asappChatService: AsappChatService
  ) {}

  onClickChat() {
    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.activatedRoute, this.asappChatService);
    chatHandler.openChatInterface();
  }
}
